/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import Button from "../../component/button/Button";
import SpinnerButton from "../../component/spinner/SpinnerButton";
import SelectInput from "../../component/input/SelectInput";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";

const CreateAccessModel = ({
  onAddAccess,
  loading,
  moduleType,
  setModuleType,
  selectedLocationId,
  setSelectedLocationId,
  showModuleTypeOptions,
  locations,
  allUserForAccess,
  setSelectUserChange,
  selectUserId,
  currentUser,
  userByLocationId,
  setUserByLocationId
}) => {
  return (
    <div
      className="modal fade"
      id="add_access"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="fullWidthModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-full-width">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="fullWidthModalLabel">
              Add Access
            </h4>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
          </div>

          <form className="pl-3 pr-3" onSubmit={onAddAccess}>
            <div className="modal-body">
              <div className="row">
                <div className="col-12">
                  <h4 className="mt-1">Add Employee Access</h4>
                  <p className="text-muted mb-2">
                    Fill the form below to Add Access .
                  </p>
                </div>
              </div>
              {isSuperAdmin(currentUser) ? (
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                    <SelectInput
                      required={true}
                      textWhite={false}
                      isLabeled={false}
                      label="Select Location To Get Users"
                      name="userByLocationId"
                      value={userByLocationId}
                      onChange={setUserByLocationId}
                    >
                      <option value=""> Select Location</option>

                      {renderLocationFunction(locations)}
                    </SelectInput>
                  </div>
                </div>
              ) : null}

              <div className="row">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <SelectInput
                    required={true}
                    textWhite={false}
                    isLabeled={false}
                    label="Select User"
                    name="selectUserId"
                    value={selectUserId}
                    onChange={setSelectUserChange}
                  >
                    <option value="">Select User</option>
                    {allUserForAccess.map((data, i) => (
                      <option key={i} value={data._id}>
                        {data.workerFirstName +
                          " " +
                          data.workerSurname}
                      </option>
                    ))}
                  </SelectInput>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <SelectInput
                    required={true}
                    textWhite={false}
                    isLabeled={false}
                    label="Select Module"
                    name="moduleType"
                    value={moduleType}
                    onChange={setModuleType}
                  >
                    <option value="">Select Module</option>
                    {showModuleTypeOptions}
                  </SelectInput>
                </div>

                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                  <SelectInput
                    required={true}
                    textWhite={false}
                    isLabeled={false}
                    label="Select Location"
                    name="selectedLocationId"
                    value={selectedLocationId}
                    onChange={setSelectedLocationId}
                  >
                    <option value=""> Select Location</option>
                    {isSuperAdmin(currentUser)
                      ? renderLocationFunction(locations)
                      : renderAccessLocation2(
                          locationRender(currentUser, false)
                        )}
                  </SelectInput>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                type="button"
                title="Close"
                data-dismiss="modal"
                className="btn btn-light"
                isBackgroundColor={false}
              />
              {loading ? (
                <SpinnerButton />
              ) : (
                <Button
                  type="submit"
                  title="Add Access"
                  className="btn btn-dark"
                  isBackgroundColor={false}
                  icon="mdi mdi-plus-circle-outline mr-2"
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

CreateAccessModel.propTypes = {
  loading: PropTypes.bool.isRequired,
  moduleType: PropTypes.string.isRequired,
  setModuleType: PropTypes.func,
  selectedLocationId: PropTypes.string.isRequired,
  setSelectedLocationId: PropTypes.func,
  showModuleTypeOptions: PropTypes.array,
  allUserForAccess: PropTypes.array,
  setSelectUserChange: PropTypes.func,
  selectUserId: PropTypes.string.isRequired,
  locations: PropTypes.array.isRequired,
  onAddAccess: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  userByLocationId: PropTypes.string.isRequired,
  setUserByLocationId: PropTypes.func.isRequired
};

export default CreateAccessModel;
